module.exports = __webpack_public_path__ + "img/UmgLogo.05f374b1.png";